
define('text!modules/profiles/subviews/templates/profile.monitoring.template.html',[],function () { return '<div class="followingIcon fa fa-eye"></div>\r\n<div class="followingTxt text">Monitor</div>';});

